import { Alert, Icon } from "@mui/material";
import React from "react";

export default function CoreAlert(props) {
  const { severity, icon, variant, children, ...restProps } = props;

  return (
    <Alert
      icon={icon ? <Icon>{icon}</Icon> : null}
      severity={severity}
      variant={variant}
      {...restProps}
    >
      {children}
    </Alert>
  );
}
